import {
  GET_SEARCH_RESULT,
  SET_SEARCH_RESULT,
  GET_LOADED_DATA,
  SET_LOADED_DATA,
  SET_SEARCHED_DATA,
  SET_RANDOM_CHART,
  GET_RANDOM_CHART,
  SET_SEARCH,
  GET_BAR_CHART_DETAILS,
  SET_BAR_CHART_DETAILS,
  GET_BAR_CHART_VALUES,
  SET_BAR_CHART_VALUES
} from "./types";

const setSearchResult = (values) => {
  return {
    type: SET_SEARCH_RESULT,
    values,
  };
};

const getSearchResult = (values) => {
  return {
    type: GET_SEARCH_RESULT,
    values,
  };
};

const setSearchedData = (values) => {
  return {
    type: SET_SEARCHED_DATA,
    values,
  };
};

const getLoadedData = (values) => {
  return {
    type: GET_LOADED_DATA,
    values,
  };
};

const setLoadedData = (values) => {
  return {
    type: SET_LOADED_DATA,
    values,
  };
};

const getRandomChart = (values) => {
  return {
    type: GET_RANDOM_CHART,
    values,
  };
};

const setRandomChart = (values) => {
  return {
    type: SET_RANDOM_CHART,
    values,
  };
};

const setSearch = (values) => {
  return {
    type: SET_SEARCH,
    values,
  };
};

const getBarChartDetails = (values) => {
  return {
    type: GET_BAR_CHART_DETAILS,
    values,
  };
};

const setBarChartDetails = (values) => {
  return {
    type: SET_BAR_CHART_DETAILS,
    values,
  };
}

const getBarChartValues = (values) => {
  return {
    type: GET_BAR_CHART_VALUES,
    values,
  };
}

const setBarChartValues = (values) => {
  return {
    type: SET_BAR_CHART_VALUES,
    values,
  };
}
export {
  setSearchResult,
  getSearchResult,
  setSearchedData,
  getLoadedData,
  setLoadedData,
  getRandomChart,
  setRandomChart,
  setSearch,
  getBarChartDetails,
  setBarChartDetails,
  getBarChartValues,
  setBarChartValues
};
